import type { Projection } from '../../common/EasyProjection/types';

const NBA_UTIL_POSITIONS = ['PG', 'PG/SG', 'SG', 'SG/PG', 'SG/SF', 'SF', 'SF/SG', 'SF/PF', 'PF', 'PF/SF', 'PF/C', 'C', 'C/PF','PG/SF','PG/C','PG/SG/SF'];
const NBA_GUARD_POSITIONS = ['PG', 'SG', 'PG/SG', 'SG/PG', 'SG/SF', 'SF/SG','PG/SF','PG/C'];
const NBA_FORWARD_POSITIONS = ['SF', 'PF', 'SF/SG', 'SG/SF', 'SF/PF', 'PF/SF', 'PF/C', 'C/PF'];

export const specialPositionsDictionary = {
  'FD': {
    'CFB': {
      'CLASSIC': {
        'SFLEX': ['QB', 'RB', 'WR'],
        'WR': ['WR', 'TE'],
        'Super FLEX': ['QB', 'RB', 'WR', 'TE'],
      },
      'SHOWDOWN': {
        'MVP - 1.5x Points': ['QB', 'RB', 'WR', 'TE', 'FLEX'],
        'FLEX': ['QB', 'RB', 'WR', 'TE'],
        'UTIL': ['QB', 'RB', 'WR', 'TE'],
      },
    },
    'NFL': {
      'CLASSIC': {
        'FLEX': ['RB', 'WR', 'TE'],
        'DEF': ['D'],
      },
      'SHOWDOWN': {
        'MVP - 1.5X Points': ['QB', 'RB', 'WR', 'TE', 'K', 'D', 'FLEX'],
        'AnyFLEX': ['QB', 'RB', 'WR', 'TE', 'K', 'D', 'FLEX'],
      }
    },
    'MLB': {
      'CLASSIC': {
        'UTIL': ['1B', '1B/2B', '1B/2B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B', '1B/3B/OF', '1B/OF', '2B', '2B/1B', '2B/1B/3B', '2B/3B', '2B/3B/1B',
         '2B/3B/1B/OF', '2B/3B/1B/SS', '2B/3B/OF', '2B/3B/SS', '2B/3B/SS/1B', '2B/3B/SS/OF',
          '2B/OF', '2B/OF/1B', '2B/SS', '2B/SS/3B', '2B/SS/3B/1B', '2B/SS/3B/OF', '2B/SS/OF',
           '3B', '3B/1B', '3B/1B/2B', '3B/2B', '3B/2B/1B', '3B/2B/OF', '3B/2B/SS', '3B/OF',
            '3B/SS', '3B/SS/2B', '3B/SS/2B/OF', 'C', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B',
             'C/OF', 'OF', 'OF/1B', 'OF/1B/2B', 'OF/2B', 'OF/2B/3B', 'OF/2B/SS', 'OF/3B',
              'OF/3B/1B', 'OF/3B/2B', 'OF/C/1B', 'SS', 'SS/1B/3B/2B', 'SS/2B', 'SS/2B/3B',
               'SS/2B/3B/OF', 'SS/2B/OF', 'SS/3B', 'SS/3B/2B', 'SS/3B/2B/OF', 'SS/3B/OF'],
        'C/1B': ['C', '1B', '2B/1B/OF', '1B/OF', 'OF/1B', '1B/2B', 'SS/3B/2B/1B/OF', 'OF/1B/3B',
        'OF/1B', '3B/SS/2B/1B', '2B/OF/1B', '1B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B/OF', '2B/1B', '2B/1B/3B', '2B/3B/1B', '2B/3B/1B/OF', '2B/3B/1B/SS',
      '2B/3B/SS/1B', '3B/1B', '3B/1B/2B', '3B/2B/1B', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B', 'C/OF', 'OF/1B/2B', 'OF/3B/1B', 'OF/C/1B', 'SS/1B/3B/2B'],
    },
    'SHOWDOWN': {
      'MVP - 1.5X Points': ['1B', '1B/2B', '1B/2B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B', '1B/3B/OF', '1B/OF', '2B', '2B/1B', '2B/1B/3B', '2B/3B', '2B/3B/1B',
       '2B/3B/1B/OF', '2B/3B/1B/SS', '2B/3B/OF', '2B/3B/SS', '2B/3B/SS/1B', '2B/3B/SS/OF',
        '2B/OF', '2B/OF/1B', '2B/SS', '2B/SS/3B', '2B/SS/3B/1B', '2B/SS/3B/OF', '2B/SS/OF',
         '3B', '3B/1B', '3B/1B/2B', '3B/2B', '3B/2B/1B', '3B/2B/OF', '3B/2B/SS', '3B/OF',
          '3B/SS', '3B/SS/2B', '3B/SS/2B/OF', 'C', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B',
           'C/OF', 'OF', 'OF/1B', 'OF/1B/2B', 'OF/2B', 'OF/2B/3B', 'OF/2B/SS', 'OF/3B',
            'OF/3B/1B', 'OF/3B/2B', 'OF/C/1B', 'SS', 'SS/1B/3B/2B', 'SS/2B', 'SS/2B/3B',
             'SS/2B/3B/OF', 'SS/2B/OF', 'SS/3B', 'SS/3B/2B', 'SS/3B/2B/OF', 'SS/3B/OF', 'P', 'SP', 'RP'],
      'UTIL': ['1B', '1B/2B', '1B/2B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B', '1B/3B/OF', '1B/OF', '2B', '2B/1B', '2B/1B/3B', '2B/3B', '2B/3B/1B',
       '2B/3B/1B/OF', '2B/3B/1B/SS', '2B/3B/OF', '2B/3B/SS', '2B/3B/SS/1B', '2B/3B/SS/OF',
        '2B/OF', '2B/OF/1B', '2B/SS', '2B/SS/3B', '2B/SS/3B/1B', '2B/SS/3B/OF', '2B/SS/OF',
         '3B', '3B/1B', '3B/1B/2B', '3B/2B', '3B/2B/1B', '3B/2B/OF', '3B/2B/SS', '3B/OF',
          '3B/SS', '3B/SS/2B', '3B/SS/2B/OF', 'C', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B',
           'C/OF', 'OF', 'OF/1B', 'OF/1B/2B', 'OF/2B', 'OF/2B/3B', 'OF/2B/SS', 'OF/3B',
            'OF/3B/1B', 'OF/3B/2B', 'OF/C/1B', 'SS', 'SS/1B/3B/2B', 'SS/2B', 'SS/2B/3B',
             'SS/2B/3B/OF', 'SS/2B/OF', 'SS/3B', 'SS/3B/2B', 'SS/3B/2B/OF', 'SS/3B/OF', 'P', 'SP', 'RP']
    }
    },
    'PGA': {
      'CLASSIC': {
      },
      'SHOWDOWN': {}
      ,
    },
    'MMA': {
      'CLASSIC': {
        'MVP - 1.5X Points': ['F'],
        'FIGHTER': ['F'],
      },
      'SHOWDOWN': {
        'MVP - 1.5X Points': ['F'],
        'FIGHTER': ['F'],
      }
      ,
    },
    'NASCAR': {
      'CLASSIC': {
        'Driver': ['D']
      },
      'SHOWDOWN': {}
      ,
    },
    'NBA': {
      'CLASSIC': {
        'G/F': ['PG', 'SG', 'SF', 'PF'],
        'F/C': ['SF', 'PF', 'C'],
        'UTIL': ['PG', 'SG', 'SF', 'PF', 'C'],
      },
      'SHOWDOWN': {
        'MVP - 2X Points': NBA_UTIL_POSITIONS,
        'MVP - 1.5X Points': NBA_UTIL_POSITIONS,
        'STAR - 1.5X Points': NBA_UTIL_POSITIONS,
        'PRO - 1.2X Points': NBA_UTIL_POSITIONS,
        'UTIL': NBA_UTIL_POSITIONS
      },
    },
  },
  'DK': {
    'CFB': {
      'CLASSIC': {
        'FLEX': ['RB', 'WR'],
        'S-FLEX': ['QB', 'RB', 'WR', 'TE'],
      },
      'SHOWDOWN': {
        'CPT': ['QB', 'RB', 'WR', 'TE', 'UTIL', 'DST', 'K', 'FLEX',],
        'UTIL': ['QB', 'RB', 'WR', 'TE', 'DST', 'K', 'FLEX',],
      }
    },
    'NFL': {
      'CLASSIC': {
        'FLEX': ['RB', 'WR', 'TE'],
      },
      'SHOWDOWN': {
        'CPT': ['QB', 'RB', 'WR', 'TE', 'DST', 'K', 'FLEX'],
        'FLEX': ['QB', 'RB', 'WR', 'TE', 'DST', 'K',],
      }
    },
    'MLB': {
      'CLASSIC': {
        'P': ['SP', 'RP']
      },
      'SHOWDOWN': {
        'CPT': ['1B', '1B/2B', '1B/2B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B', '1B/3B/OF', '1B/OF', '2B', '2B/1B', '2B/1B/3B', '2B/3B', '2B/3B/1B',
         '2B/3B/1B/OF', '2B/3B/1B/SS', '2B/3B/OF', '2B/3B/SS', '2B/3B/SS/1B', '2B/3B/SS/OF',
          '2B/OF', '2B/OF/1B', '2B/SS', '2B/SS/3B', '2B/SS/3B/1B', '2B/SS/3B/OF', '2B/SS/OF',
           '3B', '3B/1B', '3B/1B/2B', '3B/2B', '3B/2B/1B', '3B/2B/OF', '3B/2B/SS', '3B/OF',
            '3B/SS', '3B/SS/2B', '3B/SS/2B/OF', 'C', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B',
             'C/OF', 'OF', 'OF/1B', 'OF/1B/2B', 'OF/2B', 'OF/2B/3B', 'OF/2B/SS', 'OF/3B',
              'OF/3B/1B', 'OF/3B/2B', 'OF/C/1B', 'SS', 'SS/1B/3B/2B', 'SS/2B', 'SS/2B/3B',
               'SS/2B/3B/OF', 'SS/2B/OF', 'SS/3B', 'SS/3B/2B', 'SS/3B/2B/OF', 'SS/3B/OF', 'P', 'SP', 'RP'],
        'UTIL': ['1B', '1B/2B', '1B/2B/3B', '1B/2B/3B/OF', '1B/2B/SS/3B', '1B/3B', '1B/3B/OF', '1B/OF', '2B', '2B/1B', '2B/1B/3B', '2B/3B', '2B/3B/1B',
         '2B/3B/1B/OF', '2B/3B/1B/SS', '2B/3B/OF', '2B/3B/SS', '2B/3B/SS/1B', '2B/3B/SS/OF',
          '2B/OF', '2B/OF/1B', '2B/SS', '2B/SS/3B', '2B/SS/3B/1B', '2B/SS/3B/OF', '2B/SS/OF',
           '3B', '3B/1B', '3B/1B/2B', '3B/2B', '3B/2B/1B', '3B/2B/OF', '3B/2B/SS', '3B/OF',
            '3B/SS', '3B/SS/2B', '3B/SS/2B/OF', 'C', 'C/1B', 'C/1B/OF', 'C/2B/1B', 'C/2B/3B',
             'C/OF', 'OF', 'OF/1B', 'OF/1B/2B', 'OF/2B', 'OF/2B/3B', 'OF/2B/SS', 'OF/3B',
              'OF/3B/1B', 'OF/3B/2B', 'OF/C/1B', 'SS', 'SS/1B/3B/2B', 'SS/2B', 'SS/2B/3B',
               'SS/2B/3B/OF', 'SS/2B/OF', 'SS/3B', 'SS/3B/2B', 'SS/3B/2B/OF', 'SS/3B/OF', 'P', 'SP', 'RP']
      }
    },
    'PGA': {
      'CLASSIC': {
      },
      'SHOWDOWN': {
        'CPT': ['G']
      }
      ,
    },
    'MMA': {
      'CLASSIC': {
      },
      'SHOWDOWN': {}
      ,
    },
    'NASCAR': {
      'CLASSIC': {
      },
      'SHOWDOWN': {}
      ,
    },
    'NBA': {
      'CLASSIC': {
        'F': NBA_FORWARD_POSITIONS,
        'G': NBA_GUARD_POSITIONS,
        'UTIL': NBA_UTIL_POSITIONS,
      },
      'SHOWDOWN': {
        'CPT': NBA_UTIL_POSITIONS,
        'UTIL': NBA_UTIL_POSITIONS
      },
    },
  },
  'YH': {
    'NFL': {
      'CLASSIC': {
        'FLEX': ['RB', 'WR', 'TE'],
      },
      'SHOWDOWN': {}
    },
    'MLB': {
      'CLASSIC': {}
    },
    'PGA': {
      'CLASSIC': {},
      'SHOWDOWN': {}
      ,
    },
    'MMA': {
      'CLASSIC': {},
      'SHOWDOWN': {}
      ,
    },
    'NASCAR': {
      'CLASSIC': { },
      'SHOWDOWN': {}
      ,
    },
    'NBA': {
      'CLASSIC': {
        'F': NBA_FORWARD_POSITIONS,
        'G': NBA_GUARD_POSITIONS,
        'UTIL': NBA_UTIL_POSITIONS,
      },
      'SHOWDOWN': {},
    },
  },
};
type SlatePositions = { site: string; sport: string; type: string };

// Player positions are base positions (e.g. PF/C); slot names such as G/F are indivisible labels.
export const getEligiblePositions = (position: string, slate: SlatePositions): string[] => {
  const playerPositions = [position, ...position.split('/').map(p => p.trim())];
  const specialPositions: Record<string, string[]> = specialPositionsDictionary[slate.site]?.[slate.sport]?.[slate.type] ?? {};
  return Array.from(new Set([
    ...playerPositions,
    ...Object.keys(specialPositions).filter(slot => playerPositions.some(p => specialPositions[slot].includes(p))),
  ]));
};

export const prepareLineupProjections = (
  projections: Projection[], slate: SlatePositions, savedProjections: Projection[] = [],
): Projection[] => {
  const savedById = new Map(savedProjections.map(p => [p.nameAndId, p]));
  return projections.map(player => {
    const saved = savedById.get(player.nameAndId);
    // Session storage contains whole rows; only projection and ownership are editable.
    // Keep live injuries, salaries, start times and positions from the current feed.
    const customProjection = saved && Number.isFinite(saved.projection) ? saved.projection : undefined;
    const customOwnership = Object.fromEntries(
      ['ownership', 'cptOwnership', 'starOwnership', 'proOwnership']
        .filter(field => saved && Number.isFinite(saved[field]))
        .map(field => [field, saved![field]]),
    );
    return {
      ...player,
      ...customOwnership,
      ...(customProjection !== undefined ? {
        projection: customProjection,
        fppm: player.minutes > 0 ? customProjection / player.minutes : player.fppm,
      } : {}),
      canBeAddedToPositions: getEligiblePositions(player.position, slate),
    };
  });
};

export const canAddPlayerToSlot = (player: Pick<Projection, 'position' | 'canBeAddedToPositions'>, slot: string): boolean =>
  player.canBeAddedToPositions
    ? player.canBeAddedToPositions.includes(slot)
    : player.position.split('/').some(position => slot.split('/').includes(position));
